<div class="scale-container">
    <span>{{'project.scale.title' | translate}}</span> <span class="scale">1 : {{scale}}</span>
    <div class="settings">
        <div class="icon" (click)="openSettingsDialog()">
            <img width="24" height="24" src="/assets/images/settings.png"
                 srcset="/assets/images/settings.png 1x, /assets/images/settings_2x.png 2x">
        </div>
    </div>
</div>
